exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".duplicate-template-dialog .ant-form-item {\n  margin-bottom: 0;\n}\n", ""]);

// exports
